import React, { Component } from 'react'
import { connect } from 'react-redux'

import EQuoteCabinsTableAccordion from './EQuoteCabinsTableAccordion'
import EQuotePackageDetailsContainer from '../../containers/packageDetails/EQuotePackageDetailsContainer'

import triggerCustomGaEvent from '../../utilities/triggerCustomGaEvent'
import { fetchGroupAvailability } from '../../actions/fetchGroupAvailability'
import { isCategoryGroupAvailable } from '../../utilities/getGroupFilteredPricing'

import _ from 'lodash'
import GeneralTermsAndConditions from '../../components/terms/GeneralTermsAndConditions'
import EQuoteCabinsLandProgramsSelection from './EQuoteCabinsLandProgramsSelection'
import EQuoteCabinsHeader from './EQuoteCabinsHeader'

import brandLoader from '../../assets/icons/brand-loader-final.gif'

const SUPER_CAT_OPEN_STATE_KEY = {
  I: 'interiorOpen',
  O: 'oceanviewOpen',
  B: 'balconyOpen',
  D: 'deluxeOpen'
}

const findSuperCatKeyForCategoryCode = (tabularPricing, categoryCode) => {
  if (!tabularPricing || !categoryCode) return null
  const match = Object.entries(tabularPricing).find(
    ([, superCat]) =>
      superCat && superCat.pricing && superCat.pricing[categoryCode]
  )
  return match ? match[0] : null
}

class EQuoteCabinsTableContainer extends Component {
  constructor(props) {
    super(props)

    const initialOpenState = {
      interiorOpen: false,
      oceanviewOpen: false,
      balconyOpen: false,
      deluxeOpen: false
    }

    const preSelectedSuperCatKey = findSuperCatKeyForCategoryCode(
      props.activePackage && props.activePackage.tabularPricing,
      props.preSelectedCategoryCode
    )
    const openStateKey =
      preSelectedSuperCatKey && SUPER_CAT_OPEN_STATE_KEY[preSelectedSuperCatKey]
    if (openStateKey) {
      initialOpenState[openStateKey] = true
    }

    this.state = {
      ...initialOpenState,
      activeDetailsData: null,
      groupData: null
    }
  }

  componentDidMount() {
    this.fetchGroupData()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.activePackage.identifier !==
        this.props.activePackage.identifier ||
      prevProps.activePackage.landPackageIdentifier !==
        this.props.activePackage.landPackageIdentifier
    ) {
      this.setState(
        {
          interiorOpen: false,
          oceanviewOpen: false,
          balconyOpen: false,
          deluxeOpen: false,
          groupData: null
        },
        () => this.fetchGroupData()
      )
    }
  }

  fetchGroupData = async () => {
    const { activePackage, ssoData } = this.props

    if (!activePackage.groupId) {
      this.setState({ groupData: {} })
      return
    }

    const res = await fetchGroupAvailability({
      groupId: activePackage.groupId,
      agencyId: ssoData?.agency?.agency_id
    })

    this.setState({ groupData: res || {} })
  }

  superCategoryHasAvailableGroupCabins = pricing => {
    const { groupData } = this.state
    const categoryOptions = groupData?.categoryOptions

    // No group data fetched (e.g. fetch failed) — don't filter the super
    // category out. An empty array goes through and excludes the super-cat
    // when none of its categories are in the group's allocation.
    if (!categoryOptions) return true

    return Object.values(pricing).some(cabin => {
      if (!cabin || !cabin.category) return false
      return isCategoryGroupAvailable(categoryOptions, cabin.category)
    })
  }

  handleToggleEditInterior = () => {
    this.setState(
      {
        interiorOpen: !this.state.interiorOpen,
        oceanviewOpen: false,
        balconyOpen: false,
        deluxeOpen: false
      },
      () => {
        // Dispatch GA events
        triggerCustomGaEvent('buildYourQuote-cabinCategoryEdits-counter', {
          category: 'interior',
          toggledOpen: this.state.interiorOpen
        })
      }
    )
  }

  handleToggleEditOcenview = () => {
    this.setState(
      {
        interiorOpen: false,
        oceanviewOpen: !this.state.oceanviewOpen,
        balconyOpen: false,
        deluxeOpen: false
      },
      () => {
        triggerCustomGaEvent('buildYourQuote-cabinCategoryEdits-counter', {
          category: 'oceanview',
          toggledOpen: this.state.oceanviewOpen
        })
      }
    )
  }

  handleToggleEditBalcony = () => {
    this.setState(
      {
        interiorOpen: false,
        oceanviewOpen: false,
        balconyOpen: !this.state.balconyOpen,
        deluxeOpen: false
      },
      () => {
        triggerCustomGaEvent('buildYourQuote-cabinCategoryEdits-counter', {
          category: 'balcony',
          toggledOpen: this.state.balconyOpen
        })
      }
    )
  }

  handleToggleEditDeluxe = () => {
    this.setState(
      {
        interiorOpen: false,
        oceanviewOpen: false,
        balconyOpen: false,
        deluxeOpen: !this.state.deluxeOpen
      },
      () => {
        triggerCustomGaEvent('buildYourQuote-cabinCategoryEdits-counter', {
          category: 'deluxe',
          toggledOpen: this.state.deluxeOpen
        })
      }
    )
  }

  // Trigger ship details modal
  handleOpenPackageDetailsModal = (packageId, sailDate) => {
    this.props.handleOpenPackageDetailsModal()
    // Dispatch GA events
    const previewDetailsData = {
      id: packageId,
      sailDate: sailDate
    }
    triggerCustomGaEvent('equoteSearch-setSailDetails', previewDetailsData)
  }

  renderCabinTableAccordion = () => {
    const { activePackage } = this.props
    const isGroupPricing = Boolean(activePackage.groupId)

    let cabinTableData = []

    if (!_.isEmpty(activePackage.tabularPricing)) {
      const possibleStateRoomKeys = ['I', 'O', 'B', 'D']
      possibleStateRoomKeys.forEach(pricingKey => {
        const categoryData = activePackage.tabularPricing[pricingKey]
        if (
          categoryData &&
          categoryData.pricing &&
          Object.keys(categoryData.pricing).length &&
          categoryData.superCategoryData &&
          categoryData.superCategoryData.bestGuestCountRate &&
          (!isGroupPricing ||
            this.superCategoryHasAvailableGroupCabins(categoryData.pricing))
        ) {
          const stateKey =
            pricingKey === 'I'
              ? 'interiorOpen'
              : pricingKey === 'O'
              ? 'oceanviewOpen'
              : pricingKey === 'B'
              ? 'balconyOpen'
              : pricingKey === 'D'
              ? 'deluxeOpen'
              : ''

          const toggleFunction =
            pricingKey === 'I'
              ? this.handleToggleEditInterior
              : pricingKey === 'O'
              ? this.handleToggleEditOcenview
              : pricingKey === 'B'
              ? this.handleToggleEditBalcony
              : pricingKey === 'D'
              ? this.handleToggleEditDeluxe
              : null
          cabinTableData.push(
            <EQuoteCabinsTableAccordion
              key={pricingKey}
              activePackage={activePackage}
              currentCategoryData={activePackage.tabularPricing[pricingKey]}
              isEditOpen={this.state[stateKey]}
              handleToggleEdit={toggleFunction}
              groupData={this.state.groupData}
            />
          )
        }
      })
    }

    return cabinTableData
  }

  render() {
    const {
      activePackage,
      confirmationLabelsData,
      handleClosePackageDetailsModal,
      detailsModalVisible,
      showingLandPackages,
      allActivePackages
    } = this.props
    const { groupData } = this.state
    const isGroupPricing = Boolean(activePackage.groupId)
    const isLoadingGroupData = isGroupPricing && groupData === null

    return (
      <>
        <div className={'equote__cabins-table-container active'}>
          <EQuoteCabinsHeader
            activePackage={activePackage}
            handleOpenPackageDetailsModal={this.handleOpenPackageDetailsModal}
          />

          {showingLandPackages ? (
            <EQuoteCabinsLandProgramsSelection
              activePackage={activePackage}
              allActivePackages={allActivePackages}
            />
          ) : (
            <div className="equote__cabins-table-content">
              <div className="equote__cabins-table-content--header">
                <h6>{confirmationLabelsData.super_cat_section_title}</h6>
                <p>{confirmationLabelsData.super_cat_section_body}</p>
              </div>
              <div className="equote__cabins-table-content--instructions">
                <p className="u-remove-margin">
                  Use these options to select specific categories
                </p>
              </div>
              <div className="equote__cabins-table-accordions">
                {isLoadingGroupData ? (
                  <div className="u-loading-spinner">
                    <img src={brandLoader} alt="loading..." />
                    <div className="loading-message">
                      Checking Availability...
                    </div>
                  </div>
                ) : (
                  this.renderCabinTableAccordion()
                )}
              </div>

              <div className="equote__search-disclaimer ">
                <h5>Terms and Conditions</h5>
                <GeneralTermsAndConditions />
              </div>
            </div>
          )}
        </div>
        {detailsModalVisible && (
          <EQuotePackageDetailsContainer
            activeDetailsData={{
              sailDate: activePackage.departure,
              ...activePackage
            }}
            isCruiseTour={!activePackage.justACruise}
            handleClosePackageDetailsModal={handleClosePackageDetailsModal}
            detailsModalVisible={detailsModalVisible}
          />
        )}
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    ssoData: state.ssoData,
    preSelectedCategoryCode:
      (state.activeSearchFilterData &&
        state.activeSearchFilterData.categoryCode) ||
      null
  }
}

export default connect(mapStateToProps)(EQuoteCabinsTableContainer)
